<template>
    <div>

        <a-card :title="'异常详情 -'  + sysData.logstorename" :bordered="false">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <div style="min-width:940px;">
                <div style="margin-bottom:20px;">
                    <label for="">关键字：</label>
                    <a-input placeholder="" allow-clear style="width:300px;margin-left:10px;margin-right:20px;"
                        v-model="sysData.message" />

                    <label for="">开始时间：</label>
                    <a-input placeholder="" style="width:150px;margin-left:10px;margin-right:20px;"
                        v-model="sysData.mintime" />

                    <label for="">结束时间：</label>
                    <a-input placeholder="" style="width:150px;margin-left:10px;" v-model="sysData.maxtime" />

                    <a-button type="primary" style="margin-left:20px;" @click="getLogDetail">查询</a-button>
                </div>

                <itemchart ref="itemChart"></itemchart>

                <div class="dashBox" style="margin-top:20px;">
                        <div class="dashTitle">异常日志<span style="color:#333;font-size:12px;padding-left:20px;">仅显示100条数据</span></div>
                        
                        <a-list  :data-source="tableData" style="min-height:100px;">
                            <!-- <a-spin :spinning="tLoading"></a-spin> -->
                            <a-list-item slot="renderItem" slot-scope="item, index">
                                <div class="list_item_box">
                                    <div class="list_item_head">
                                        <span class="colom_index">{{  index + 1}}</span>
                                        <span class="colom_time">{{item.时间}}</span>
                                    </div>
                                    <div class="list_item_data">
                                        <div class="list_item_data_item" v-for="key in filterColoms" :key="key">
                                            <div class="list_item_data_item_key">{{key}}</div>
                                            <span>:</span>
                                            <span class="list_item_data_item_value" v-html="handleTraceid(item[key],key)"></span>
                                        </div>
                                    </div>
                                </div>

                            </a-list-item>
                        </a-list>
                </div>
            </div>
        </a-card>
    </div>
</template>
<script>

import itemchart from './itemchart'
export default {
    data() {
        return {
            filterColoms : ['trace_id','time','thread','class','level','logger_category','logger_filter1','logger_filter2','logger_module','logger_subcategory','message'],
            sysData:{
                projectname:'',
                logstorename:'',
                message:'',
                mintime:'',
                maxtime:'',
                pv:0,
                chartPerTime:''
                
            },
            tableData:[],
            tLoading:false,
            expandLoading:false,
            t_start:'',
            t_end:'',
        };
    },
    methods: {
        handleTraceid(msg,key){
            if(key == 'trace_id'){
                msg = msg.replace('[','');
                msg = msg.replace(']','')
                msg = msg.trim();
                let traceid = msg
                let traceHtml = '<a href="/ui/#/monitorservice/relation?traceid=' + traceid + '&starttime='+this.t_start+'&endtime='+this.t_end+'" target="blank_">' + traceid + '</a> '
                return traceHtml
            }
            else{
                return msg
            }
        },
        getLogDetail(){
            let that = this;
            let currentM = new Date(that.sysData.maxtime).getTime();

            if(that.sysData.mintime == that.sysData.maxtime){
                currentM += 1000;
            }
            let starttime = (new Date(that.sysData.mintime).getTime())/1000;
            let endtime = (currentM)/1000;
            this.getChart(starttime,endtime);
            this.t_start = new Date(that.sysData.mintime).getTime() - 1000 * 60;
            this.t_end = currentM
            setTimeout(() => {
                that.getList(starttime,endtime);
            },500);
        },
        getChart(starttime,endtime){
            this.$refs.itemChart.loadData(this.sysData.message,starttime,endtime,this.sysData.projectname,this.sysData.logstorename,this.sysData.chartPerTime);
        },
        getList(starttime,endtime){
            let queryStr = "* | select * from log where message like '%" + this.sysData.message + "%'";
            // let queryStr = "message: '" + this.sysData.message + "*'"
            let that = this;
           
            let params = {
                projectname:that.sysData.projectname,
                logstorename:that.sysData.logstorename,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize: 100,
                offset:0,
                reverse:false,
                paged:false,
                timeout:15000,
                urlparams:false
            };
            that.tLoading = true;
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){

                    let result = res.data.data;
                    console.log(result)
                    that.tableData = result.list;

                }
                that.tLoading = false;

            }).catch(() => {
                that.tLoading = false;
            });
        }
    },


    components:{
        itemchart
    },
    mounted(){
        let sysmsg = localStorage.getItem("currentSystemMsg");
        try {
            sysmsg = JSON.parse(sysmsg);
            this.sysData.message = sysmsg.exception;
            if(!this.sysData.mintime || !this.sysData.maxtime){
                this.sysData.mintime = new Date(sysmsg.mintime).Format("yyyy-MM-dd hh:mm:ss") ;
                this.sysData.maxtime = new Date(sysmsg.maxtime).Format("yyyy-MM-dd hh:mm:ss") ;
            }
            
            this.sysData.pv = sysmsg.pv;
            this.sysData.projectname = sysmsg.projectname;
            this.sysData.logstorename = sysmsg.logstorename;
            this.sysData.chartPerTime = sysmsg.chartPerTime;

            if(!this.sysData.projectname || !this.sysData.logstorename ){
                this.$router.back(-1);
            }
        } catch (error) {
            this.$router.back(-1);
        }
        this.getLogDetail();

    }
};
</script>
<style scoped>
 .list_item_box{
        width: auto;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 10px 13px;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
    }
    .list_item_head{

        padding-right: 5px;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -moz-box-orient: horizontal;
        -moz-box-direction: normal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        -moz-box-sizing: content-box;
        box-sizing: content-box;
    }
    .colom_index{
        color: #333;
        font-size: 12px;
        margin-top: 3px;
    }
    .colom_time{
        margin-top: 2px;
        margin-left: 10px;
        padding-right: 5px;
        font-weight: 700;
        color: #333;
        font-size: 12px;
        white-space: nowrap;
    }
    .list_item_data{
        flex: 1;
        box-sizing: border-box;
        display: block;
    }
    .list_item_data_item{
        font-family: Roboto Mono,Consolas,Menlo,Courier,monospace;
        display: block;
        word-break: break-word;
        word-wrap: break-word;
        line-height: 16px;
        margin-right: 5px;
    }
    .list_item_data_item_key{
        display: inline-flex;
        color: #333;
        font-size: 12px;
        background-color: rgba(0,86,144,.1);
        border-radius: 2px;
        padding: 1px 3px!important;
        margin: 2px 0;
    }

    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
        cursor: default;
    }
</style>
